import React from "react";
import {InboxOutlined} from "@mui/icons-material";
import "./feedback.css";

/**
 * Пустое состояние списка/блока.
 */
const EmptyState = ({icon, title = "Пока пусто", description, action, compact = false}) => (
    <div className={`ui-empty${compact ? " ui-empty--compact" : ""}`}>
        <div className="ui-empty__icon">{icon || <InboxOutlined/>}</div>
        <div className="ui-empty__title">{title}</div>
        {description && <div className="ui-empty__description">{description}</div>}
        {action && <div className="ui-empty__action">{action}</div>}
    </div>
);

export default EmptyState;
